/**
 * @param {Function} callback callback function
 * @param {String} globalName global name
 */
function exposeGlobalFunctionAndExecuteQueue(callback, globalName) {
  const queue = window[globalName] || [];

  window[globalName] = {
    push: function () {
      for (let index = 0; index < arguments.length; index++) {
        callback(arguments[index]);
      }
    },
  };

  for (let index = 0; index < queue.length; index += 1) {
    window[globalName].push(queue[index]);
  }
}

export default exposeGlobalFunctionAndExecuteQueue;
